import React, { useEffect, useState } from "react";
import Button from "./Button";

let results = {
    data: [],
    hasNextPage: false,
}

//pagination component
const Pagination = ({ page, setPage, pages, hasNextPage }) => {

    //handler for the previous button    
    function handlePrevious() {
        setPage(page - 1)
    }
    //handler for the next button   
    function handleNext() {
        setPage(page + 1)
    }

    return (
        <div className="p-5 flex items-center justify-content text-gray-600">
            <Button
                onClick={handlePrevious}
                disabled={page <= 1}>
                Previous
            </Button>
            {pages - page < 1 && page - 4 > 0 && <Button onClick={() => setPage(pages - 4)}>{page - 4}</Button>}
            {pages - page < 2 && page - 3 > 0 && <Button onClick={() => setPage(pages - 4)}>{page - 4}</Button>}
            {pages && page -2 > 0 && <Button onClick={() => setPage(pages - 2)}>{page - 2}</Button>}
            {pages && page -1 > 0 && <Button onClick={() => setPage(pages - 1)}>{page - 1}</Button>}
            <Button>
                {/* active={true} */}
                {page}
            </Button>
            {page + 1 <= pages && <Button onClick={() => setPage(pages + 1)}>{page + 1}</Button>}
            {page + 2 <= pages && <Button onClick={() => setPage(pages + 2)}>{page + 2}</Button>}
            {page + 3 <= pages && <Button onClick={() => setPage(pages + 3)}>{page + 3}</Button>}
            {page + 4 <= pages && <Button onClick={() => setPage(pages + 4)}>{page + 4}</Button>}
            <Button
                onClick={handleNext}
                disabled={!hasNextPage}>
                Next
            </Button>
        </div>
    );
}


export default Pagination

function ResultData({ data }) {
    const [page, setPage] = useState(1)
    const pages = 12
    useEffect(() => {

    }, [page])

    return (
        <div>
            {/* <ResultsList data={data} /> */}
            <Pagination page={page} setPage={setPage} hasNextPage={page < pages} />
        </div>
    )
}